/* eslint-disable filename-export/match-default-export */

import React from 'react';
import pt from 'prop-types';
import ReactAceEditor from '../react-ace-editor';
import { ACE_EDITOR_DEFAULT_OPTIONS, ACE_EDITOR_DEFAULT_PROPS } from '../ace-editor-defaults';
import './ace-diff-viewer.scss';

const PANE_CLASS_NAME = `${ACE_EDITOR_DEFAULT_PROPS.className} ace-diff-pane read-only`;

export default function AceDiffPane({ name, lang, value, height, foldable, onEditorLoad }) {
  return (
    <ReactAceEditor
      {...ACE_EDITOR_DEFAULT_PROPS}
      className={PANE_CLASS_NAME}
      name={name}
      mode={lang}
      value={value}
      readOnly
      height={height}
      setOptions={buildPaneOptions(foldable)}
      onLoad={onEditorLoad}
    />
  );
}

AceDiffPane.propTypes = {
  name: pt.string.isRequired,
  lang: pt.string.isRequired,
  value: pt.string.isRequired,
  height: pt.string,
  foldable: pt.bool,
  onEditorLoad: pt.func,
};

function buildPaneOptions(foldable) {
  if (!foldable) {
    return ACE_EDITOR_DEFAULT_OPTIONS;
  }

  return {
    ...ACE_EDITOR_DEFAULT_OPTIONS,
    showFoldWidgets: true,
    foldStyle: 'markbegin',
  };
}
